import { render, staticRenderFns } from "./SelectAPhoto.vue?vue&type=template&id=48e39dff&"
import script from "./SelectAPhoto.vue?vue&type=script&lang=js&"
export * from "./SelectAPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports